import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router'; // Add this
import { ReactiveFormsModule } from '@angular/forms';
import { AdvisoropPanelComponent } from './components/advisorop-panel/advisorop-panel.component';
import { PanelBodyDirective } from './directives/panel-body.directive';
import { PanelFooterDirective } from './directives/panel-footer.directive';
import { PanelToolsDirective } from './directives/panel-tools.directive';
import { UserInfoNavComponent } from './components/user-info-nav/user-info-nav.component';
import { SharedLayoutComponent } from './components/shared-layout/shared-layout.component';
import { DxButtonModule, DxDataGridModule, DxPopupModule, DxCheckBoxModule, DxLoadPanelModule } from 'devextreme-angular';
import { RmdTrackerComponent } from './components/rmd-tracker/rmd-tracker.component';
import { RmdTrackerApiService } from './services/rmd-tracker.service';
import { GeneralService } from './services/general.service'
import { AdvisoryFirmApiService } from './services/advisory-firm-api.service'
import { FormsModule } from '@angular/forms';
import { RmdCellTemplateComponent } from './components/rmd-cell-template/rmd-cell-template.component';
import { RmdCalculatorComponent } from './components/rmd-calculator/rmd-calculator.component';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { AccountNotesComponent } from './components/account-notes/account-notes.component';
import { AddNoteComponent } from './components/add-note/add-note.component';

@NgModule({
  declarations: [
    AdvisoropPanelComponent,
    PanelBodyDirective,
    PanelFooterDirective,
    PanelToolsDirective,
    UserInfoNavComponent,
    SharedLayoutComponent,
    RmdTrackerComponent,
    RmdCellTemplateComponent,
    RmdCalculatorComponent,
    AccountNotesComponent,
    AddNoteComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    DxButtonModule,
    DxDataGridModule,
    DxPopupModule,
    DxCheckBoxModule,
    DxLoadPanelModule,
    FormsModule,
    NgbTypeaheadModule,
    ReactiveFormsModule
  ],
  providers: [
    RmdTrackerApiService,
    GeneralService,
    AdvisoryFirmApiService
  ],
  exports: [
    PanelBodyDirective,
    PanelFooterDirective,
    PanelToolsDirective,
    AdvisoropPanelComponent,
    UserInfoNavComponent,
    DxButtonModule,
    DxDataGridModule,
    DxPopupModule,
    DxCheckBoxModule,
    DxLoadPanelModule,
    RmdTrackerComponent,
    FormsModule,
    RmdCellTemplateComponent,
    NgbTypeaheadModule,
    ReactiveFormsModule
  ], // Export the component for reuse
})
export class SharedModule { }
